enum ScheduleBoardSortType {
	OFFICE_AND_JOB_NUMBER_ASC = 'OFFICE_AND_JOB_NUMBER_ASC',
	OFFICE_AND_JOB_NUMBER_DESC = 'OFFICE_AND_JOB_NUMBER_DESC',
	FREE_REORDERING = 'FREE_REORDERING'
}

export default ScheduleBoardSortType;
